import type { FC, ReactNode } from "react";
import { twMerge } from "tailwind-merge";

import { EmailLoginForm } from "./EmailLoginForm";

import { LOGO_FORM_SIZE } from "components/constants";
import { t } from "i18n/i18n";
import { TrackedLink } from "mds/components/TrackedLink";
import { ForumLogoIcon } from "mds/icons";

interface LoginViewProps {
  className?: string;
  onLoggedIn: () => void;
  children?: ReactNode;
}

export const LoginView: FC<LoginViewProps> = ({ className, onLoggedIn, children }) => {
  const passwordResetMessage =
    new URLSearchParams(window.location.search).get("password_reset") === "true";

  return (
    <div className={twMerge("m-2 w-full max-w-[18rem] p-4 md:w-96", className)}>
      <header className="mb-3 flex items-center justify-between border-b border-black-tint-90 bg-white pb-1 text-black-tint-20">
        <span className="mb-2 flex cursor-pointer items-center">
          <ForumLogoIcon width={LOGO_FORM_SIZE} />
        </span>
      </header>

      <main>
        <h2 className="mb-3 text-black-tint-20">{t("user_info.login_title")}</h2>

        {passwordResetMessage && (
          <span className="mb-2 flex cursor-pointer">
            <p>{t("user_info.login_after_password_reset")}</p>
          </span>
        )}

        <EmailLoginForm onLoggedIn={onLoggedIn}>{children}</EmailLoginForm>

        <TrackedLink
          className="mb-2 mt-8 block cursor-pointer text-sm font-normal text-black-tint-40 underline"
          eventName="Account - Sign in / Forgot password"
          id="forgot-password"
          to="/forgot-password"
        >
          {t("user_info.forgot_password")}
        </TrackedLink>
      </main>
    </div>
  );
};
